import React, { Component } from 'react';

class CancelCaseModal extends Component {
  _onCancelCaseBack = () => {
    const { onCancelCaseBack } = this.props;
    onCancelCaseBack();
  }

  render() {
    const { onCancelCase, onCaseRowAcmCase } = this.props;

    return (
      <div
        className="modal fade theme-modal" id="cancelCaseModal"
        tabIndex="-1" aria-labelledby="cancelCaseModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="cancelCaseModalLabel">Cancel Case</h5>
              {
                (onCaseRowAcmCase.ACMCaseID !== '' && onCaseRowAcmCase.CreateRep === 'ACM')
                  ? (
                    <div>
                      <p>
                        This is an ACM case. If canceled,
                        no further updates will be received from ACM.
                      </p>
                      <p>
                        Are you sure you want to cancel?
                      </p>
                    </div>
                  )
                  : <p>Are you sure you want to cancel this case?</p>
              }
            </div>

            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" onClick={this._onCancelCaseBack}>No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onCancelCase()}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CancelCaseModal;
